export default __webpack_public_path__ + "static/char-s-56-ko-b4864c86b1ca6ee02786b17aa1d73c0d.webp";